require("jquery-ui/ui/widgets/autocomplete");
require("./jquery-ui.combobox.js"); // a custom widget

$(function() {
  $('select.ui-combobox-enabled').combobox({
    uiComboboxShowAllItems: '選択肢を表示',
    uiComboboxNotMatch: '${value} は選択肢にありません',
    uiComboboxNotMatchDelayTime: 5000,
    uiComboboxAdditionalClasses: ['form-control']
  });

  $('#q_name_cont').autocomplete({
    source: function(request, response) {
      $.ajax({
        type: 'GET',
        url: this.element.data('autocomplete-source-url') +'?pref='+ $('#q_prefecture_code_eq').val() +'&term='+ request.term,
        dataType: 'json',
      })
      .done(function(res) {
        console.log(res);
        response(res);
      })
      .fail(function(res) {
        console.error(res);
      });
    }
  });

  $('#q_hospital_name_cont').autocomplete({
    source: function(request, response) {
      $.ajax({
        type: 'GET',
        url: this.element.data('autocomplete-source-url') +'?pref='+ $('#q_hospital_prefecture_code_eq').val() +'&term='+ request.term,
        dataType: 'json',
      })
      .done(function(res) {
        console.log(res);
        response(res);
      })
      .fail(function(res) {
        console.error(res);
      });
    }
  });
});
